import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';

export enum PerioExamEditExamConfirmationEnum {
  Cancel,
  FinishAndEdit,
}

@Component({
  selector: 'lib-perio-edit-exam-confirmation-modal',
  imports: [TranslatePipe],
  templateUrl: './perio-edit-exam-confirmation-modal.component.html',
  styleUrl: './perio-edit-exam-confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioEditExamConfirmationModalComponent {
  private readonly dialogRef = inject(DialogRef<PerioExamEditExamConfirmationEnum>);

  protected onCancelClick(): void {
    this.dialogRef.close(PerioExamEditExamConfirmationEnum.Cancel);
  }

  protected onFinishAndEditClick(): void {
    this.dialogRef.close(PerioExamEditExamConfirmationEnum.FinishAndEdit);
  }
}
